import axios from 'axios';

const BASE_URL = process.env.REACT_APP_DIFF_ENGINE_API;

export const arsDataIngestionApi = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});
